import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=2c83a3dc"
import script from "./CardSkeleton.vue?vue&type=script&lang=js"
export * from "./CardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CardSkeleton.vue?vue&type=style&index=0&id=2c83a3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports